module.exports = __webpack_public_path__ + "img/e_3_23_g.e19c84e4.png";